import Vue from 'vue';
import Router from 'vue-router';
import Artists from './views/Artists.vue';
import Artist from './views/Artist.vue';
import Albums from './views/Albums.vue';
import Album from './views/Album.vue';
import Lyrics from './views/Lyrics.vue';
import Lyric from './views/Lyric.vue';
import Logs from './views/Logs.vue';
import Status from './views/Status.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/artists',
            name: 'artists',
            component: Artists
        },
        {
            path: '/artist/:id',
            name: 'artist',
            component: Artist
        },     
        {
            path: '/albums',
            name: 'albums',
            component: Albums
        },
        {
            path: '/album/:id',
            name: 'album',
            component: Album
        },  
        {
            path: '/lyrics',
            name: 'lyrics',
            component: Lyrics
        },
        {
            path: '/lyric/:id',
            name: 'lyric',
            component: Lyric
        },  
        {
            path: '/logs',
            name: 'logs',
            component: Logs
        },
        {
            path: '/status',
            name: 'status',
            component: Status
        }  
    ]
});
